export const ANNUAL_BOILER_SERVICE_NORMAL_LINK =
  'https://www.ovoenergy.com/annual-boiler-service';
export const ANNUAL_BOILER_SERVICE_TERMS_LINK =
  'https://homeservices.ovoenergy.com/terms-abs.pdf';
export const ANNUAL_BOILER_SERVICE_DESCRIPTION =
  'A Gas Safe engineer will service your boiler and check it’s running safely and efficiently.';
export const ANNUAL_BOILER_SERVICE_TITLE = 'Annual boiler service';
export const ANNUAL_BOILER_SERVICE_GET_SERVICE_PLAN = 'Get your service plan';
export const ANNUAL_BOILER_SERVICE_INFO_LINK_TEXT = 'What’s included?';

export const BOILER_LIST = [
  'Less than 18 years old',
  'A brand we service',
  'In good working condition',
  'Not insured by OVO or CORGI HomePlan',
];
